import React from "react";
import { useNavigate } from "react-router-dom";

interface NavButtonProps {
  title: string;
  icon: React.ReactNode;
  className?: string;
  link: string;
  toggle?: () => void;
}

const NavButton = (props: NavButtonProps) => {
  const navigate = useNavigate();

  function handleNavigation() {
    navigate(link);
    if (toggle) toggle();
  }
  const { title, icon, className, link, toggle } = props;

  return (
    <button
      onClick={handleNavigation}
      className={`flex items-center w-full text-left text-sm text-gray-400 px-2 py-3 rounded-md hover:text-white ${className}`}
    >
      {icon}
      <span className="ml-4">{title}</span>
    </button>
  );
};

export default NavButton;
